import { render } from "./GuestCoCrb.vue?vue&type=template&id=8701f1bc&scoped=true"
import script from "./GuestCoCrb.vue?vue&type=script&lang=js"
export * from "./GuestCoCrb.vue?vue&type=script&lang=js"

import "./GuestCoCrb.vue?vue&type=style&index=0&id=8701f1bc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8701f1bc"]])

export default __exports__